import store from './GenericStore.js';
export default store;

// export default from './GenericStore';
// export const UIDMethod = xUIDMethod;
